<template>
  <div class="multiple-blanks">
    <div v-for="(answer,index) in issue.fillContext" :key="answer.id">
      <div class="mt-3 mb-1" v-html="answer.content.richText"></div>
      <div class="van-field-border">
        <relation-input
          :option-id="answer.id"
          :question-type="question.questionType"
          :question-id="question.id"
          v-model="answer.value"
          :type="answer.inputType"
          :enable-relation="issue.setting.enableRelation"
          :disable-copy="issue.disableCopy"
          :readonly="answer.readonly"
          :placeholder="answer.placeholder"
        />
        <template v-if="errorList[index]">
          <div class="text-danger mt-1">
            <span>{{errorList[index]}}</span>
          </div>
        </template>
        <!--        <van-field v-model="answer.value" :type="answer.inputType" />-->
      </div>
      <adapter-upload-files :content="answer.content" />
    </div>
  </div>
</template>

<script>
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import RelationInput from '../components/RelationInput'

export default {
  name: 'MultipleBlanks',
  components: { RelationInput, AdapterUploadFiles },
  changeExpr: 'changeExpr',
  data(){
    return {
      errorList:[]
    }
  },
  computed: {
    changeExpr() {
      return this.issue.fillContext.map(item => item.value + item.content.fileList.length).join('-')
    }
  },
  created() {
    this.errorList = new Array(this.issue.fillContext.length)
  },
  watch:{
    'question.questionErrorList'(list){
      this.errorList = new Array(this.issue.fillContext.length)
      this.issue.fillContext.forEach((item,index)=>{
        const key = `${this.question.id}.${item.id}`
        const i = list.find(i=>i.key === key)
        if(!i) return
        this.errorList[index] = i.message
      })
    }
  }
}
</script>
